import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=bf034c06&scoped=true"
import script from "./PropertyDetail.vue?vue&type=script&lang=js"
export * from "./PropertyDetail.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=bf034c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf034c06",
  null
  
)

export default component.exports